export const OPTIONS = {
    comma: true, // required to parse comma separated string into array
    arrayFormat: 'comma' as const, // required to stringify arrays into comma separated strings
    indices: false, // don't use array indices
    encode: false, // don't encode the entire string as it will be done individually for certain params
    decode: false,
    skipNulls: true, // required to remove empty params
};
